<template>
    <div>
        <div class="card">
            <DataTable
                ref="dt"
                :value="delinquents"
                class="text-sm shadow"
                :paginator="true"
                :rows="10"
                :rowsPerPageOptions="[5,10,25,50,100]"
                :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} clientes inadimplentes">

                <template #header>
                    <div class="flex flex-wrap gap-2 align-items-center justify-content-between">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText class="bg-white p-3 pl-10 border" v-model="filters['global'].value" placeholder="Buscar inadimplentes..." />
                        </span>
                    </div>
                </template>

                <Column field="name" header="Cliente" sortable></Column>
                <Column field="document" header="Documento" sortable></Column>
                <Column field="pending_count" header="Pedidos Pendentes" sortable class="text-center">
                    <template #body="slotProps">
                        <span class="bg-red-100 text-red-700 font-bold px-2.5 py-1 rounded-full text-xs">
                            {{ slotProps.data.pending_count }}
                        </span>
                    </template>
                </Column>
                <Column field="pending_total" header="Valor Pendente" sortable>
                    <template #body="slotProps">
                        <span class="font-bold text-red-600">
                            {{ formatCurrency(slotProps.data.pending_total) }}
                        </span>
                    </template>
                </Column>
                <Column field="oldest_date" header="Mais Antigo Desde" sortable>
                    <template #body="slotProps">
                        {{ formatDate(slotProps.data.oldest_date) }}
                    </template>
                </Column>
                <Column field="payment_methods" header="Métodos de Pagamento">
                    <template #body="slotProps">
                        <div class="flex flex-wrap gap-1">
                            <span v-for="method in slotProps.data.payment_methods" :key="method" class="bg-slate-100 text-slate-700 px-2 py-0.5 rounded text-xs uppercase font-medium">
                                {{ getPaymentMethodLabel(method) }}
                            </span>
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import { FilterMatchMode } from 'primevue/api'
import dateService from '@/services/dateService'

export default {
    name: 'TableDelinquents',
    props: {
        delinquents: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    components: {
        DataTable, Column, InputText
    },
    data() {
        return {
            filters: {}
        }
    },
    created() {
        this.initFilters();
    },
    methods: {
        initFilters() {
            this.filters = {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            }
        },
        formatCurrency(value) {
            if (value !== undefined && value !== null) {
                return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            }
            return 'R$ 0,00';
        },
        formatDate(date) {
            if (!date) return '-';
            return dateService.formatBR(date);
        },
        getPaymentMethodLabel(method) {
            const labels = {
                pix: 'Pix',
                credit_card: 'Cartão',
                ticket: 'Boleto'
            };
            return labels[method] || method;
        }
    }
}
</script>

<style scoped>
.p-input-icon-left {
    position: relative;
    display: inline-block;
}
.p-input-icon-left > i {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
}
</style>
